import { useQuery } from '@tanstack/react-query';

import { get } from './api';

export interface DemoModeInfo {
  demoMode: boolean;
  signatureMocked: boolean;
  mocked: string[];
  warning: string | null;
  /** Подписывает ли работник лично через NCALayer; иначе подпись ставит сервер. */
  workerSignsPersonally?: boolean;
  /** Адрес кабинета ЕСУТД: у стенда и боевого контура он разный, а сборка одна. */
  esutdWebUrl?: string | null;
}

/**
 * Режим стенда берётся с бэкенда, а не из флага сборки: одна и та же сборка фронта
 * работает и на демонстрационном стенде, и в бою, а расходиться с фактическим
 * состоянием сервиса плашка и подсказки не должны.
 *
 * Запрос без токена — `/auth/config` открыт, иначе страница входа не смогла бы
 * узнать, что она на стенде.
 */
export function useDemoMode(): DemoModeInfo | undefined {
  const { data } = useQuery({
    queryKey: ['auth', 'config'],
    queryFn: () => get<DemoModeInfo>('/auth/config'),
    // Режим не меняется без перезапуска сервиса — перечитывать незачем.
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
  return data;
}
